import { render, staticRenderFns } from "./add-or-edit-md.vue?vue&type=template&id=05c158f6&scoped=true&"
import script from "./add-or-edit-md.vue?vue&type=script&lang=js&"
export * from "./add-or-edit-md.vue?vue&type=script&lang=js&"
import style0 from "./add-or-edit-md.vue?vue&type=style&index=0&id=05c158f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c158f6",
  null
  
)

export default component.exports